import { BroadcastChannel } from 'broadcast-channel';
import Config from 'config';
import { useEffect, useState } from 'react';

const channel = new BroadcastChannel('singleTab', {
    webWorkerSupport: false,
    idb: {
        onclose: async () => {
            await channel.close();
        },
    },
});
const { isMarketing } = Config;

export const useSingleTab = () => {
    const [isLeader, setLeader] = useState(true);

    useEffect(() => {
        channel.postMessage(`I'm the new leader!`).then();
        channel.addEventListener('message', () => {
            setLeader(false);
        });
    }, []);

    return isLeader || isMarketing;
};
